import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { type AxiosResponse } from "axios";
import { awsClientGateway } from "./common/gateway";
import { logMessage } from "../utils/amplifyLogger";
import { clientLog } from "./logging";

type RejectFn = (value: string) => unknown;

const getTranslateData = async (
  languageCode: string,
  translatePayload: Record<string, unknown>,
  rejectWithValue: RejectFn,
): Promise<AxiosResponse | unknown> => {
  try {
    const response = await awsClientGateway({
      pathTemplate: `/translate/${languageCode}`,
      method: "POST",
      body: { ...translatePayload },
    });
    return response;
  } catch (error) {
    clientLog({
      component: `translate`,
      message: `Something went wrong in translate API => ${error}`,
    });
    logMessage(
      `translate`,
      `Something went wrong in translate API => ${error}`,
      `error`,
    );
    return rejectWithValue("Error in translate api endpoint");
  }
};

export interface TranslatePayload {
  languageCode: string;
  [key: string]: unknown;
}

export const getTranslate = createAsyncThunk<unknown, TranslatePayload>(
  "translate/getTranslate",
  async (translatePayload: TranslatePayload, { rejectWithValue }) => {
    const { languageCode, ...payload } = translatePayload;
    return await getTranslateData(languageCode, payload, rejectWithValue);
  },
);

export const getResetTranslate = createAction("translate/getResetTranslate");
